export default "__VITE_ASSET__DJbdeBD4__"